import Layout from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { api } from "@/lib/api";
import { Plus } from "lucide-react";
import { useState } from "react";
import ExameEdit from "./exames-edit";
import ExameList from "./exames-list";
import { Exame } from "./interfaces/Exame.interface";

const ExamesPage = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [editingExame, setEditingExame] = useState<Exame | null>(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleEdit = (exame: Exame) => {
    setEditingExame(exame);
    setOpen(true);
  };

  const handleDelete = async (id: number) => {
    if (confirm("Deseja realmente excluir este exame?")) {
      try {
        await api.delete(`/api/exames/${id}`);
        toast({
          title: "Sucesso",
          description: "Exame excluído com sucesso!",
        });
        // Recarrega a lista de exames
        setRefreshTrigger(prev => prev + 1);
      } catch (error: any) {
        console.error("Erro ao excluir exame:", error);
        toast({
          title: "Erro",
          description: error.response?.data?.message || "Erro ao excluir exame",
          variant: "destructive",
        });
      }
    }
  };

  const handleSuccess = () => {
    // Recarrega a lista de exames
    setRefreshTrigger(prev => prev + 1);
    setOpen(false);
    setEditingExame(null);
  };

  return (
    <Layout>
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-3xl font-bold tracking-tight text-foreground">Exames</h2>
            <p className="text-muted-foreground mt-1">Gerencie o cadastro de exames disponíveis</p>
          </div>
          <Button
            className="gap-2"
            onClick={() => {
              setEditingExame(null);
              setOpen(true);
            }}
          >
            <Plus className="h-4 w-4" />
            Novo Exame
          </Button>
        </div>

        <ExameList
          onEdit={handleEdit}
          onDelete={handleDelete}
          refreshTrigger={refreshTrigger}
        />

        <ExameEdit
          open={open}
          onOpenChange={setOpen}
          exame={editingExame}
          onSuccess={handleSuccess}
        />
      </div>
    </Layout>
  );
};

export default ExamesPage;
